import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cut-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.8787 15.3789L4 3.50023M15 8.5L20 3.5M8.12109 15.3789L11.9998 11.5002M15.8787 15.3787C17.0503 14.2071 18.9497 14.2071 20.1213 15.3787C21.2929 16.5503 21.2929 18.4497 20.1213 19.6213C18.9497 20.7929 17.0503 20.7929 15.8787 19.6213C14.7071 18.4497 14.7071 16.5503 15.8787 15.3787ZM8.12132 15.3787C9.29289 16.5503 9.29289 18.4497 8.12132 19.6213C6.94975 20.7929 5.05025 20.7929 3.87868 19.6213C2.70711 18.4497 2.70711 16.5503 3.87868 15.3787C5.05025 14.2071 6.94975 14.2071 8.12132 15.3787Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 6.5V6M12 2.5V2","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Cut1 = Vue.extend<IconProps>({
  name: 'Cut1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cut-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Cut1;
